var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.patientInfo)?_c('patient-profile-form',{attrs:{"patientInfo":_vm.patientInfo}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }